import { handleException } from 'clients/exception-handling'
import { DEFAULT_PANEL_FIELDS } from 'features/charts-v2/constants'
import type { ChartPanel } from 'features/charts-v2/types/filter-hash/v2'
import type { ChartRequest } from 'features/charts-v2/types/yogiql'
import { storedQueryFields, type YogiQLNames } from 'features/charts-v2/utils'
import type { FilterOption } from 'features/filters/types'

/** What the chat draws for one chart artifact. */
export type YogiQLChatChart =
  | { status: 'legacy' }
  | { status: 'pending' }
  | { status: 'unavailable' }
  | { status: 'ready'; panel: ChartPanel; names: YogiQLNames }

/** A YogiQL chat chart's artifact request is `{request: <ChartRequest>, chart_type}`. */
export const isYogiQLChatRequest = (
  request: Record<string, unknown>,
): boolean =>
  typeof request['request'] === 'object' && request['request'] !== null

/** A stored request as a panel, or null after recording why it does not read. */
export const readChatChartRequest = (
  stored: ChartRequest,
  options: FilterOption[] | null,
  reasons: string[],
): ChartPanel | null => {
  if (!options) return null
  let fields: ReturnType<typeof storedQueryFields>
  try {
    fields = storedQueryFields(stored, { filterOptions: options })
  } catch (error) {
    handleException(error, { operation: 'conversation.chart.fields' })

    fields = `the request does not read: ${String(error)}` // not a crash
  }
  if (typeof fields === 'string') {
    reasons.push(fields)
    return null
  }
  return { ...DEFAULT_PANEL_FIELDS, ...fields } as ChartPanel
}
